const URLserv = "https://enterviza.kai-doc.com.ua/api";
const URLclient = "https://enterviza.kai-doc.com.ua";

const API = {
    URLserv: URLserv,
    URLclient: URLclient
};

export default API;
